module.exports = __webpack_public_path__ + "img/topo_login.4cc319ec.png";